var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8833 10.7927C14.8833 9.56959 14.8389 8.57812 15.5716 8.57812H19.6217C20.3545 8.57812 20.1903 9.56959 20.1903 10.7927V19.651C20.1903 20.8741 20.3545 21.8656 19.6217 21.8656H15.5716C14.8389 21.8656 14.8833 20.8741 14.8833 19.651V10.7927Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53605 15.2224C9.53605 13.9993 9.37636 13.0078 10.1146 13.0078H14.2246C14.9628 13.0078 14.883 13.9993 14.883 15.2224V19.6515C14.883 20.8747 15.0825 21.8661 14.3443 21.8661H10.1944C9.45616 21.8661 9.53605 20.8747 9.53605 19.6515V15.2224Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22951 17.4501C4.22951 16.2307 4.14519 15.2422 4.87793 15.2422H8.92801C9.66075 15.2422 9.53652 16.2307 9.53652 17.4501V19.658C9.53652 20.8775 9.74055 21.866 9.00781 21.866H4.87793C4.14519 21.866 4.22951 20.8775 4.22951 19.658V17.4501Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56934 21.8789H22.8506",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56543 8.08782C4.30083 8.4669 5.3107 8.62584 6.52045 8.55308C7.7302 8.4802 9.10892 8.17747 10.5547 7.66699C12.0005 7.15664 13.4765 6.45167 14.8736 5.60424C16.2707 4.75682 17.5533 3.78858 18.6265 2.77106M15.9088 2.22461L18.8407 2.62341L18.022 5.88469",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.515e18de959b2c9c491700c76b8c9e27.svg";
export { ForwardRef as ReactComponent };